import React, { useState, useEffect } from "react";
import { useAuth } from "../components/AuthContext";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import "../styles/Auth.css";

export default function VerifyOtpPage() {

  const {
    emailForOtp,
    verifyOtp,
    forgotPassword,
  } = useAuth();

  const navigate = useNavigate();
  const location = useLocation();

  const source = location.state?.source || "shop";

  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);

  // Resend OTP Timer
  const [countdown, setCountdown] = useState(60);
  const [canResend, setCanResend] = useState(false);

  console.log("Location State:", location.state);
  console.log("Source:", source);

  /* =========================================
      OTP COUNTDOWN
  ========================================= */

  useEffect(() => {

    if (canResend) return;

    const timer = setInterval(() => {

      setCountdown((prev) => {

        if (prev <= 1) {

          clearInterval(timer);

          setCanResend(true);

          return 0;

        }

        return prev - 1;

      });

    }, 1000);

    return () => clearInterval(timer);

  }, [canResend]);

  /* =========================================
      VERIFY OTP
  ========================================= */

  const handleSubmit = async (e) => {

    e.preventDefault();

    if (!emailForOtp) {

      toast.error("No email found. Please register first.");

      navigate("/register");

      return;

    }

    if (otp.length !== 6) {

      toast.warning("Enter a valid 6-digit OTP");

      return;

    }

    setLoading(true);

    try {

      const res = await verifyOtp(emailForOtp, otp);

      console.log("================================");
      console.log("VERIFY OTP RESPONSE");
      console.log(res);
      console.log("Response Token:", res?.token);
      console.log("Response User:", res?.user);
      console.log("Local Token:", localStorage.getItem("token"));
      console.log("Local User:", localStorage.getItem("user"));
      console.log("Source:", source);
      console.log("================================");

      if (!res.success) {

        toast.error(res.message || "Invalid OTP");

        return;

      }

      toast.success("Email verified successfully!");

      setOtp("");

      if (source === "game") {

        navigate("/coming-soon", {
          replace: true,
        });

      } else {

        navigate("/profile", {
          replace: true,
        });

      }

    } catch (err) {

      console.error("VERIFY OTP ERROR:", err);

      toast.error(
        err?.response?.data?.message ||
        "Verification failed"
      );

    } finally {

      setLoading(false);

    }

  };

  /* =========================================
      RESEND OTP
  ========================================= */

  const handleResendOtp = async () => {

    if (!emailForOtp || !canResend) return;

    try {

      const res = await forgotPassword(emailForOtp);

      if (res.success) {

        toast.success("OTP resent successfully");

        setCountdown(60);

        setCanResend(false);

      } else {

        toast.error(res.message);

      }

    } catch (err) {

      toast.error("Unable to resend OTP");

    }

  };

  return (

    <div className="auth-page">

      <div className="auth-card">

        <h2>Verify Email</h2>

        <p>

          We've sent a 6-digit OTP to

          <br />

          <strong>{emailForOtp}</strong>

        </p>

        <form onSubmit={handleSubmit}>

          <input
            type="text"
            placeholder="Enter 6-digit OTP"
            value={otp}
            maxLength={6}
            onChange={(e) =>
              setOtp(
                e.target.value.replace(/\D/g, "")
              )
            }
            required
          />

          <button
            type="submit"
            disabled={loading}
          >
            {loading
              ? "Verifying..."
              : "Verify OTP"}
          </button>

        </form>

        <p className="resend-text">

          {canResend ? (

            <>

              Didn't receive OTP?{" "}

              <span
                className="resend-link"
                onClick={handleResendOtp}
              >
                Resend OTP
              </span>

            </>

          ) : (

            <>

              Resend OTP in{" "}

              <strong>

                {countdown}s

              </strong>

            </>

          )}

        </p>

      </div>

    </div>

  );

}